import { useURLQueryParams } from "./useURLQueryParams";

export function useGetQueryParam(paramName) {
  const params = useURLQueryParams();
  const paramValue = params.get(paramName);

  return { paramValue };
}
